import { Drawing } from "drawing";
import { isInFrameX } from "./derive.js";
import { FRAMEX_PAGE_OUTLINE } from "./colors.js";

/**
 * A cheap key that changes only when a FrameX per-sheet flag or the page
 * selection changes, so the canvas repaints on FrameX state (and off-canvas
 * selection like a chip click) without re-firing on every `doc.data` mutation.
 * Selection must be in the key or a chip click won't repaint until a hover.
 */
export function framexRepaintKey(visiblePages, doc, selectedPages) {
  return (visiblePages || [])
    .map((id) => {
      const p = doc?.data?.pages?.[id];
      const sel = selectedPages?.[id] ? 1 : 0;
      return `${p?.scale ?? ""}:${p?.notApplicable ? 1 : 0}${p?.framexExcluded ? 1 : 0}${p?.detectDone ? 1 : 0}:${sel}`;
    })
    .join("|");
}

/** The gold membership ring for a page tile, or null when it shouldn't show. */
export function framexPageRing(page, { br, tl }, { active }) {
  if (!active || !isInFrameX(page)) return null;
  return new Drawing()
    .rectangle(br.x - 2, br.y - 2, tl.x - br.x + 4, tl.y - br.y + 4)
    .style({ stroke: FRAMEX_PAGE_OUTLINE, fill: "transparent", lineWidth: 2 });
}
